export default "__VITE_ASSET__e9f3c02d__"